import VoiceRecordItem from "./VoiceRecordItem";

function VoiceRecordsList({ 
    generatedVoices, 
    isSelectingVoice, 
    selectedVoiceForAvatar, 
    onVoiceSelect, 
    onCancelSelection, 
    onCopy , currentPlayingId, isPlaying, onPlayVoice
}) {
    try {
        if (!generatedVoices || generatedVoices.length === 0) {
            return null;
        }

        return (
            <div className="mt-3 bg-blue-50 p-3 rounded-lg border border-blue-200">
                <div className="flex justify-between items-center mb-2">
                    <h4 className="font-medium text-blue-800">
                        <i className="fas fa-history mr-2"></i>
                        已生成的語音記錄 ({generatedVoices.length})
                    </h4>
                    
                    {isSelectingVoice && (
                        <button
                            onClick={onCancelSelection}
                            className="text-sm px-3 py-1 bg-gray-400 text-white rounded hover:bg-gray-500 transition-colors"
                            data-name="cancel-selection-button"
                        >
                            <i className="fas fa-times mr-1"></i>
                            取消選擇
                        </button>
                    )}
                </div>
                
                {isSelectingVoice && (
                    <div className="bg-yellow-50 p-2 rounded-lg mb-2 text-sm text-yellow-700 flex items-center">
                        <i className="fas fa-info-circle mr-2"></i>
                        請選擇一個語音記錄用於生成數字人
                    </div>
                )}
                
                <div className="space-y-2">
                    {generatedVoices.map((voice, voiceIndex) => (
                        <VoiceRecordItem 
                            key={voice.id}
                            voice={voice}
                            voiceIndex={voiceIndex}
                            isSelectingVoice={isSelectingVoice}
                            isSelected={selectedVoiceForAvatar === voice.id}
                            onSelect={onVoiceSelect}
                            onPlayVoice={onPlayVoice}
                            onCopy={onCopy}
                            currentPlayingId={currentPlayingId}
                            isPlaying={isPlaying}
                        />
                    ))}
                </div>
            </div>
        );
    } catch (error) {
        console.error('VoiceRecordsList component error:', error);
        reportError(error);
        return null;
    }
}

export default VoiceRecordsList;